/* eslint-disable @typescript-eslint/ban-types */
import React, { ElementType, forwardRef, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import { baseTheme, defaultTheme, typographyPxSizes, typographyRemSizes, withTheme } from '@shared/lib/theme';
type SizeValue = keyof typeof typographyRemSizes['size'];
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
interface TextProps extends HTMLAttributes<HTMLParagraphElement> {
  as?: ElementType;
  size?: ResponsiveSize;
  weight?: keyof typeof baseTheme['typography']['weight'];
  family?: keyof typeof baseTheme['typography']['family'];
  color?: keyof typeof defaultTheme['colors']['text'] | (string & {});
  textTransform?: 'uppercase' | 'lowercase' | 'none';
}
const Text = forwardRef<HTMLParagraphElement, TextProps>(({
  size = 'pL',
  weight = 'medium',
  family = 'MTSWide',
  color = 'primary',
  textTransform = 'none',
  children,
  ...rest
}, ref) => {
  const desktopSize = typeof size === 'object' ? size.desktop || 'pL' : size || 'pL';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 'pL';
  return <TextWrapper ref={ref} desktopSize={desktopSize} mobileSize={mobileSize} weight={weight} color={color} family={family} textTransform={textTransform} {...rest}>
        {children}
      </TextWrapper>;
});
export default Text;

// todo - можно убрать константы typographyRemSizes, typographyPxSizes, брать значения из темы
const _exp = /*#__PURE__*/() => ({
  family,
  theme
}) => theme.typography.family[family];
const _exp2 = /*#__PURE__*/() => ({
  weight,
  theme
}) => theme.typography.weight[weight];
const _exp3 = /*#__PURE__*/() => ({
  desktopSize
}) => typographyRemSizes.size[desktopSize];
const _exp4 = /*#__PURE__*/() => ({
  desktopSize
}) => typographyRemSizes.lineHeight[desktopSize];
const _exp5 = /*#__PURE__*/() => ({
  desktopSize
}) => typographyRemSizes.letterSpacing[desktopSize];
const _exp6 = /*#__PURE__*/() => ({
  color,
  theme
}) => color in theme.colors.text ? theme.colors.text[color] : color;
const _exp7 = /*#__PURE__*/() => ({
  textTransform
}) => textTransform;
const _exp8 = /*#__PURE__*/() => ({
  mobileSize
}) => typographyPxSizes.size[mobileSize];
const _exp9 = /*#__PURE__*/() => ({
  mobileSize
}) => typographyPxSizes.lineHeight[mobileSize];
const _exp0 = /*#__PURE__*/() => ({
  mobileSize
}) => typographyPxSizes.letterSpacing[mobileSize];
const TextWrapper = withTheme(/*#__PURE__*/styled('p')({
  name: "TextWrapper",
  class: "t1jrvwce",
  propsAsIs: false,
  vars: {
    "t1jrvwce-0": [_exp()],
    "t1jrvwce-1": [_exp2()],
    "t1jrvwce-2": [_exp3()],
    "t1jrvwce-3": [_exp4()],
    "t1jrvwce-4": [_exp5()],
    "t1jrvwce-5": [_exp6()],
    "t1jrvwce-6": [_exp7()],
    "t1jrvwce-7": [_exp8()],
    "t1jrvwce-8": [_exp9()],
    "t1jrvwce-9": [_exp0()]
  }
}));

require("./Text.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Text.tsx");